import React, { useState, useEffect } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { getSiteSettings } from '../../api/siteSettings';

const Marriage = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await getSiteSettings();
        if (response.isSuccess) {
          setSiteSettings(response.data);
        }
      } catch (error) {
        console.error('Error fetching site settings:', error);
      }
    };

    fetchSiteSettings();
  }, []);
  return (
    <div className="marriage-page">
      <div className="container lg-py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="marriage-content">
              <h1 className="page-title">Nikah İşlemleri</h1>
              
              <div className="marriage-info">
                <h2>İskenderun Belediye Başkanlığı Nikâh Başvurusu İçin Gerekli Belgeler</h2>
                <p>İskenderun Belediyesi'nde nikâh başvurusu yapmak isteyen çiftler için gerekli belgeler ve başvuru koşulları aşağıda belirtilmiştir.</p>

                <div className="required-documents">
                  <h3>Gerekli Belgeler:</h3>
                  <ul>
                    <li>
                      <strong>Çiftlerin Birlikte Başvuru Yapması Gerekmektedir</strong>
                      <p>Nikâh başvurusu için çiftlerin birlikte başvurması zorunludur.</p>
                    </li>
                    <li>
                      <strong>Müracaata Gelemeyen Taraf İçin Vekil Atanması</strong>
                      <ul>
                        <li>Başvuruya katılamayan taraf, noter aracılığıyla bir vekil atayarak, yerini imzalayabilir.</li>
                        <li>Vekaletnamede, vekil tarafından yapılacak işlemlere dair açıkça belirtilmiş olan onaylı T.C. kimlik fotokopisi de yer almalıdır.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Sağlık Raporu</strong>
                      <ul>
                        <li>Evlilik başvurusu için, sağlık ocağında SMA ve Akdeniz Anemisi testlerinin yapılması gereklidir.</li>
                        <li>Aile hekimi tarafından düzenlenen sağlık raporunda, "Evlenme mevzuatı gereği kişilerin evlenmeye engel olabilecek hastalıklardan salim olduğu anlaşılmıştır." ibaresinin yer alması zorunludur.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Kimlik Fotokopisi</strong>
                      <ul>
                        <li>Çiftlerin her biri için 1 adet kimlik fotokopisi gerekmektedir.</li>
                        <li>Kimliklerin asılları başvuru esnasında ibraz edilmelidir.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Vesikalık Fotoğraf</strong>
                      <ul>
                        <li>Çiftlerin 4'er adet vesikalık fotoğraf sunması gerekmektedir.</li>
                        <li>Fotoğraflar son 6 ay içinde çekilmiş, ön cepheden ve biyometrik olmayan vesikalık fotoğraf olmalıdır.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Yerleşim Yeri Belgesi</strong>
                      <ul>
                        <li>İskenderun ilçesi dışında ikamet eden başvuru sahiplerinin yerleşim yeri belgesi alması gerekmektedir.</li>
                        <li>Yerleşim yeri belgesi, e-devlet üzerinden alınabilir.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Zarf</strong>
                      <p>Başvuru için 1 adet A4 boyutunda zarf gerekmektedir.</p>
                    </li>
                  </ul>
                </div>

                <div className="important-notes">
                  <h3>Dikkat Edilmesi Gereken Hususlar:</h3>
                  <ul>
                    <li>
                      <strong>Yaş Sınırları:</strong>
                      <ul>
                        <li>18 yaşını dolduran, vesayet altına alınmayan erkek ve kadınlar, başkalarının rızasına gerek olmadan evlenebilir.</li>
                        <li>17 yaşını dolduranlar, velisinin veya vesayet makamının izniyle evlenebilir.</li>
                        <li>16 yaşını dolduranlar ise hakim izniyle evlenebilir.</li>
                        <li>Ayırt etme gücüne sahip olmayanlar ve 15 yaşını dolduran küçükler, mahkeme kararıyla dahi evlenemez.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Boşanmış Kadınlar İçin Süre Kısıtlaması</strong>
                      <p>Boşanmış, evliliği geçersiz sayılmış veya eşi ölmüş kadınlar, kocasının ölüm tarihinden veya boşanma kararından itibaren 300 gün geçmeden evlenemez. Ancak, bu süre mahkeme kararı ile kısaltılabilir veya kaldırılabilir.</p>
                    </li>
                    <li>
                      <strong>Evlenme Beyanname Onayı</strong>
                      <p>Başvuruda gerekli belgeleri tamamlayan ve evlenmesine engel bir durumu bulunmayan çiftlere, yurt içinde ve yurt dışında evlenme işlemlerini gerçekleştirebilmeleri için onay verilir. Bu onay, verildiği tarihten itibaren 6 ay geçerlidir.</p>
                    </li>
                    <li>
                      <strong>Kızlık Soyadı Kullanımı</strong>
                      <p>Kızlık soyadını kullanmak isteyen kadınlar, evlendirme memurunun önünde bir dilekçe imzalayarak bu haklarını kullanabilirler.</p>
                    </li>
                    <li>
                      <strong>Evlenme Dosyasının Geçerlilik Süresi</strong>
                      <p>Evlilik başvuru dosyasının geçerlilik süresi, evlenme ehliyet belgesinin düzenlenmesinden itibaren 6 ay ile sınırlıdır. Bu süre içinde evlenme işlemi gerçekleştirilmezse, dosya iptal edilir.</p>
                    </li>
                  </ul>
                </div>

                <img className='pageimg' src="/assets/images/nikah.webp" alt="" />

                <div className="contact-info">
                  <h3>Müracaat Saatleri ve İletişim</h3>
                  <div className="info-item">
                    <FaClock className="info-icon" />
                    <div>
                      <strong>Çalışma Saatleri:</strong>
                      <p>Pazartesi - Cuma: 08:00-12:00, 13:00-17:00</p>
                      <p className="text-danger">Not: Ücret ödemelerinin yapılacağı veznemiz saat 16.00'da kapanmaktadır.</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <FaPhone className="info-icon" />
                    <div>
                      <strong>İrtibat:</strong>
                      <p>0 531 611 90 69</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <FaMapMarkerAlt className="info-icon" />
                    <div>
                      <strong>Adres:</strong>
                      <p>PİRİREİS MAHALLESİ TOKİ MİLLET BAHÇESİ</p>
                    </div>
                  </div>
                </div>
                
                <div className="marriage-button-container" style={{ textAlign: 'center', marginTop: '2rem' }}>
                  {/* <a 
                    href={siteSettings?.marriageProceduresUrl || "https://webportal.iskenderun.bel.tr/webportal/index.php?wwsayfa=999999"} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-lg"
                    style={{
                      backgroundColor: '#1e3799',
                      borderColor: '#1e3799',
                      padding: '12px 30px',
                      color: '#fff',
                      fontSize: '18px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Nikah İşlemleri İçin Tıklayın
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marriage;
